export default (n, block) => {
  let acc = ''
  for (let i = 0; i < n; ++i) {
    acc += block.fn({ i })
  }
  return acc
}
